import { render, staticRenderFns } from "./GatewayDetail.vue?vue&type=template&id=5b75a6e5&"
import script from "./GatewayDetail.vue?vue&type=script&lang=js&"
export * from "./GatewayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b75a6e5')) {
      api.createRecord('5b75a6e5', component.options)
    } else {
      api.reload('5b75a6e5', component.options)
    }
    module.hot.accept("./GatewayDetail.vue?vue&type=template&id=5b75a6e5&", function () {
      api.rerender('5b75a6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/GatewayDetail.vue"
export default component.exports